import { render, staticRenderFns } from "./NewOrganizationModal.vue?vue&type=template&id=67f1ab8e&"
import script from "./NewOrganizationModal.vue?vue&type=script&lang=ts&"
export * from "./NewOrganizationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67f1ab8e')) {
      api.createRecord('67f1ab8e', component.options)
    } else {
      api.reload('67f1ab8e', component.options)
    }
    module.hot.accept("./NewOrganizationModal.vue?vue&type=template&id=67f1ab8e&", function () {
      api.rerender('67f1ab8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizations/NewOrganizationModal.vue"
export default component.exports